import React from "react";
import { QrcodeOutlined } from "@ant-design/icons";


const QrCodeIcon = ({ className }) => (
    <QrcodeOutlined className={ className } />
);

export default QrCodeIcon;
